import { Link } from "react-router-dom";
import { ArrowRight, Rocket, Store, ShoppingBag, Cpu, MapPin } from "lucide-react";
import Breadcrumb from "../components/Breadcrumb";
import SectionLabel from "../components/SectionLabel";
import ScrollReveal from "../components/ScrollReveal";
import { INDUSTRIES_DETAIL } from "../lib/data";

const ICONS = { Rocket, Store, ShoppingBag, Cpu, MapPin };

export default function IndustriesOverview() {
  return (
    <div className="page" data-testid="industries-page">
      <section className="page-hero">
        <div className="container-x">
          <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Industries", to: "/industries" }]} />
          <h1 style={{ marginTop: 16 }}>Industries We Serve.</h1>
          <p className="lead">From early-stage startups to established local brands — design tuned to the realities of your sector.</p>
        </div>
      </section>

      <section className="section section-bright">
        <div className="container-x">
          <SectionLabel num={1}>Sectors</SectionLabel>
          <h2 className="sec-title">Five sectors, one playbook.</h2>

          <div className="industry-grid">
            {INDUSTRIES_DETAIL.map((ind, i) => {
              const Ic = ICONS[ind.icon] || Rocket;
              return (
                <ScrollReveal key={ind.slug} delay={i * 80}>
                  <Link to={`/industries/${ind.slug}`} className="industry-card" data-testid={`ind-card-${ind.slug}`}>
                    <div className="ic-large"><Ic size={26} /></div>
                    <h3>{ind.title}</h3>
                    <p>{ind.short}</p>
                    <span className="learn-link">Learn More <ArrowRight size={14} /></span>
                  </Link>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </section>

      <div className="container-x">
        <div className="cta-dark">
          <div className="lead">Different industry?</div>
          <h2>Tell me about your business and I'll tell you how I can help.</h2>
          <Link to="/contact" className="btn btn-light">Get In Touch <ArrowRight size={16} /></Link>
        </div>
      </div>
    </div>
  );
}
